import type { IconData } from '@stacksjs/iconify-core'

export const fireExtinguisher: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.231 8.926a1.8 1.8 0 1 1-3.6 0a1.8 1.8 0 0 1 3.6 0\"/><path fill=\"currentColor\" d=\"M56.263.792c-.001 0-48.862-.016-48.846 0C2.914.792.381 3.121.381 7.878v49.04c0 4.45 2.278 6.78 6.776 6.78h49.248c4.5 0 6.779-2.215 6.779-6.78V7.878c0-4.641-2.279-7.086-6.92-7.086zM54.93 17.446l-15.539-2.349v-1.358h-6.35l-.009 2.195c1.743.327 6.319 3.122 6.319 8.552V56.04c0 .783-.365 2.087-1.931 2.087H23.522c-1.567 0-1.931-1.304-1.931-2.087V24.486c0-5.43 4.744-8.226 6.466-8.552l-.007-1.839c-4.177 1.044-5.583 3.223-6.837 4.998s-3.692.287-2.804-1.488c.639-1.862 3.876-4.92 6.29-5.811c-.61-.366-1.299-1.44-1.299-2.641c0-2.529 1.944-4.204 4.09-4.204c2.204 0 3.755 1.831 3.755 3.258h1.827v2.296h6.319V9.041L54.93 6.782z\"/>",
  "width": 63,
  "height": 64,
  "viewBox": "0 0 63 64"
}

export default fireExtinguisher
